import { cache } from 'react'
import { ITag } from '../_types'
import { request } from './http-client'

// ✅ CACHED: Server-side caching for tags
export const getTags = cache(async (params: Record<string, string | number>) => {
  try {
    const response = await request.get<{ tags: ITag[]; count: string }>(
      `/v1/tags`,
      { params }
    )
    return response
  } catch (error) {
    console.error('Error:', error)
    return null
  }
})
